import { render, staticRenderFns } from "./SvgEditor.vue?vue&type=template&id=da9af48c&scoped=true&"
import script from "./SvgEditor.vue?vue&type=script&lang=js&"
export * from "./SvgEditor.vue?vue&type=script&lang=js&"
import style0 from "./SvgEditor.vue?vue&type=style&index=0&id=da9af48c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9af48c",
  null
  
)

export default component.exports